import {useViewNavigate} from '@common'
import {NavigationPathKey, TranslationKey} from '@enums'
import {Stack} from '@mui/material'
import {SearchTableWrapper} from '@wrappers'

import React from 'react'

import {ComposedComponents, UIKit} from '@components'

import {ContractSearchTab, LegacyTab, useContractSearchModel} from './contract-search-model'

/**
 * Contract Search page
 */
export function ContractSearchPage() {
  const navigate = useViewNavigate()
  const {
    t,
    legacyColumns,
    legacyRows,
    rows,
    activeTab,
    tabButtons,
    visibilityModel,
    columns,
    legacyVisibilityModel,
    activeLegacyTab,
    legacyTabButtons,
    filterConfig,
    legacyFilterConfig,
  } = useContractSearchModel()

  return (
    <>
      <ComposedComponents.TabButtons activeTab={activeTab} buttons={tabButtons} />
      <SearchTableWrapper>
        {activeTab === ContractSearchTab.CONTRACTS && (
          <UIKit.Table
            buttonProps={{
              buttonText: t(TranslationKey['Add new contract']),
              onClick: () => navigate(NavigationPathKey.CONTRACT_CREATION),
            }}
            columns={columns}
            filterConfig={filterConfig}
            rows={rows.contracts}
            visibilityModel={visibilityModel}
            title={t(TranslationKey['List of contracts'])}
          />
        )}

        {activeTab === ContractSearchTab.QUOTES && (
          <UIKit.Table
            buttonProps={{
              buttonText: t(TranslationKey['Add new contract']),
              onClick: () => navigate(NavigationPathKey.CONTRACT_CREATION),
            }}
            columns={columns}
            filterConfig={filterConfig}
            rows={rows.quotes}
            visibilityModel={visibilityModel}
            title={t(TranslationKey['List of quotes'])}
          />
        )}

        {activeTab === ContractSearchTab.LEGACY && (
          <Stack spacing={2}>
            <ComposedComponents.TabButtons activeTab={activeLegacyTab} buttons={legacyTabButtons} />

            {activeLegacyTab === LegacyTab.FLOORPLAN_DEMO ? (
              <UIKit.Table
                columns={legacyColumns}
                filterConfig={legacyFilterConfig}
                rows={legacyRows[LegacyTab.FLOORPLAN_DEMO]}
                visibilityModel={legacyVisibilityModel}
                title={'Floorplan/Demo'}
              />
            ) : (
              <UIKit.Table
                columns={legacyColumns}
                filterConfig={legacyFilterConfig}
                rows={legacyRows[LegacyTab.OP_LEASE]}
                visibilityModel={legacyVisibilityModel}
                title={'Op. Lease'}
              />
            )}
          </Stack>
        )}
      </SearchTableWrapper>
    </>
  )
}
